import React from 'react';
import dropdownChevron from '../../assets/images/dropdown-chevron.svg';
const OppurtunitiesInTribe = () => {
  return ( 
    <div className="oppurtunities-in-tribe">
      <p className="font-weight-extrabold fs-18 text-black">OPPURTUNITIES IN THE TRIBE</p>
      <p className="font-weight-thin fs-85 text-primary">Discover the right<br></br> role for you.</p>
      <div className="row">
        <div className="col-md-4">
          <p className="fs-14 text-gray text">There’s room at SmartDrive for every talent—and<br></br> talent from almost everywhere. We’d love for you to<br></br> join us. Discover the right role for you.</p>
        </div>
        <div className="col-md-2">
          <button className="btn btn-outline-primary btn-block">Location
          <span className="caret ml-5"><img src={dropdownChevron} alt="Dropdown Chevron" /></span></button>
        </div>
        <div className="col-md-2">
          <button className="btn btn-outline-primary btn-block role-btn">Role
          <span className="caret ml-5"><img src={dropdownChevron} alt="Dropdown Chevron" /></span></button>
        </div>
      </div>
      <div className="oppurtunities">
        <hr></hr>
        <div className="row">
          <div className="col-md-6">
            <p className="fs-20">Role</p>
            <p className="fs-24 text-secondary">Corporate recuiter</p>
          </div>
          <div className="col-md-2">
            <p className="fs-20">Sub-team</p>
            <p className="fs-24 text-secondary">TBD</p>
          </div>
          <div className="col-md-2">
            <p className="fs-20">Location</p>
            <p className="fs-24 text-secondary">Gachibowli</p>
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary br-0 fs-24 pl-4 pr-4 mt-4">Apply</button>
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-md-6">
            <p className="fs-20">Role</p>
            <p className="fs-24 text-secondary">Corporate recuiter</p>
          </div>
          <div className="col-md-2">
            <p className="fs-20">Sub-team</p>
            <p className="fs-24 text-secondary">TBD</p>
          </div>
          <div className="col-md-2">
            <p className="fs-20">Location</p>
            <p className="fs-24 text-secondary">Gachibowli</p>
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary br-0 fs-24 pl-4 pr-4 mt-4">Apply</button>
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-md-6">
            <p className="fs-20">Role</p>
            <p className="fs-24 text-secondary">Corporate recuiter</p>
          </div>
          <div className="col-md-2">
            <p className="fs-20">Sub-team</p>
            <p className="fs-24 text-secondary">TBD</p>
          </div>
          <div className="col-md-2">
            <p className="fs-20">Location</p>
            <p className="fs-24 text-secondary">Gachibowli</p>
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary br-0 fs-24 pl-4 pr-4 mt-4">Apply</button>
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-md-6">
            <p className="fs-20">Role</p>
            <p className="fs-24 text-secondary">Corporate recuiter</p>
          </div>
          <div className="col-md-2">
            <p className="fs-20">Sub-team</p>
            <p className="fs-24 text-secondary">TBD</p>
          </div>
          <div className="col-md-2">
            <p className="fs-20">Location</p>
            <p className="fs-24 text-secondary">Gachibowli</p>
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary br-0 fs-24 pl-4 pr-4 mt-4">Apply</button>
          </div>
        </div>
      </div>
    </div>
   );
}
 
export default OppurtunitiesInTribe;